import controller from './testimonies.controller';
import template1 from './testimonies.view-t1.html';

let TestimoniesComponent = {
    template: template1,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        type: '@',
        itemId: '@'
    }
};

export default TestimoniesComponent;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/testimonies/testimonies.component.js
 **/